// Ingram 1949 - PDP dettagli: i tab su mobile.   15/09
//
// Minimo per definizione: il markup e' gia' completo e servito dal server, i
// quattro pannelli stanno tutti nell'HTML. Questo file non carica, non chiede e
// non costruisce niente: sposta due attributi.
//
//   aria-selected  sul pulsante
//   data-attivo    sul pannello  -> e' il CSS a nascondere quelli a "false",
//                                   e solo sotto i 750px.
//
// Su desktop il CSS ignora data-attivo e mostra tutti i pannelli in sequenza:
// se questo file non viene eseguito, la pagina resta quella del pezzo 1, cioe'
// quattro pannelli aperti. Nessun contenuto sparisce senza JS.
//
// Non definisce un custom element: si aggancia a `.ingram-pdp` gia' presente,
// per non dover riscrivere il markup della sezione.

function collega(radice) {
  const tab = [...radice.querySelectorAll('[role="tab"]')];
  const pannelli = tab
    .map((t) => radice.querySelector('#' + CSS.escape(t.getAttribute('aria-controls'))))
    .filter(Boolean);

  if (tab.length === 0 || tab.length !== pannelli.length) return;

  const apri = (i) => {
    if (i < 0 || i >= tab.length) return;
    tab.forEach((t, k) => {
      const attivo = k === i;
      t.setAttribute('aria-selected', attivo ? 'true' : 'false');
      t.setAttribute('tabindex', attivo ? '0' : '-1');
      pannelli[k].dataset.attivo = attivo ? 'true' : 'false';
    });
  };

  radice.addEventListener('click', (e) => {
    const t = e.target.closest('[role="tab"]');
    if (t && tab.includes(t)) apri(tab.indexOf(t));
  });

  // Frecce e Home/End, come da pratica per un tablist.
  radice.addEventListener('keydown', (e) => {
    const i = tab.indexOf(document.activeElement);
    if (i < 0) return;
    const n = tab.length;
    let d = null;
    if (e.key === 'ArrowRight') d = (i + 1) % n;
    if (e.key === 'ArrowLeft') d = (i - 1 + n) % n;
    if (e.key === 'Home') d = 0;
    if (e.key === 'End') d = n - 1;
    if (d === null) return;
    e.preventDefault();
    apri(d);
    tab[d].focus();
  });
}

// Il codice nel pannello Descrizione.   16/09
//
// `product-sku-component` di Horizon ascolta il cambio di variante solo dentro
// `[id*="ProductInformation-"]`: il nostro sta in un'altra sezione, quindi
// restava fermo sulla variante di apertura (visto il 16/09 cliccando una
// taglia: il codice nativo passava a _03, il nostro restava _02).
// Qui si copia il testo del codice nativo, gia' aggiornato dal tema. Se lo
// SKU e' vuoto la riga la nasconde il CSS (`.sku:empty`).
function specchiaCodice() {
  const info = document.querySelector('[id*="ProductInformation-"]');
  const nostri = [...document.querySelectorAll('.ingram-pdp__sku [ref="sku"]')];
  if (!info || nostri.length === 0) return;

  const copia = () => {
    const nativo = info.querySelector('product-sku-component [ref="sku"]');
    if (!nativo) return;
    const testo = nativo.textContent.trim();
    nostri.forEach((n) => {
      if (n.textContent !== testo) n.textContent = testo;
    });
  };

  new MutationObserver(copia).observe(info, { subtree: true, childList: true, characterData: true });
  copia();
}

function avvia() {
  document.querySelectorAll('.ingram-pdp').forEach(collega);
  specchiaCodice();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', avvia);
} else {
  avvia();
}